import { useQuery } from "react-query";
import { getAdvertisements } from "api/services/advertisements";
import { EAdvertisementsQueryKeys } from "api/endpoints/advertisements";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TAdvertisement } from "types/api/advertisement";

export const useAdvertisements = () => {
  return useQuery<TAdvertisement[], TApiError>(
    [EAdvertisementsQueryKeys.getAdvertisements],
    getAdvertisements,
    {
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
